<div class="outer-div">
  <div class="inner-div">
    <div class="chat">
      <div
        *ngFor="let script of allTranscripts; let i = index"
        class="chat-line"
      >
        <p class="chat-p">{{ script }}</p>
        <button
          *ngIf="copiedIndex != i"
          class="copy-btn"
          (click)="copyToClipboard(script, i)"
          title="Copy to clipboard"
        >
          📋
        </button>
        <!--  Copied Message -->
        <span *ngIf="copiedIndex === i" class="copied-message">✔ Copied</span>
      </div>
    </div>
    <div>
      <p *ngIf="transcript"><strong>You said:</strong> {{ transcript }}</p>
      <p *ngIf="error" style="color: red">Error: {{ error }}</p>
    </div>

    <div class="mb-3">
      <button
        (click)="clearBuffer()"
        [disabled]="isListening"
        class="mx-3 my-1"
        [disabled]="!allTranscripts || allTranscripts.length == 0"
      >
        Clear Buffer
      </button>
      <button
        (click)="startListening()"
        [disabled]="isListening"
        class="mx-3 my-1"
      >
        Start Listening
      </button>
      <button
        (click)="stopListening()"
        [disabled]="!isListening"
        class="mx-3 my-1"
      >
        Stop Listening
      </button>
    </div>
  </div>
</div>
